import { SVGProps } from ".";

export function EraserIcon({ color = "black", size = 18 }: SVGProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        color={`${color}`}
        height={`${size}`}
        width={`${size}`}
        stroke={`${color}`}
        strokeWidth="0"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          d="M9.77996 9.81091L5.89491 13.7598L9.82483 17.7544C9.91892 17.85 10.0475 17.9038 10.1817 17.9037L11.6003 17.9026C11.7341 17.9024 11.8624 17.8487 11.9563 17.7532L14.775 14.8881L9.77996 9.81091ZM10.89 8.68263L15.885 13.7598L18.105 11.5033L13.11 6.42609L10.89 8.68263ZM14.0296 17.9024H19.0239C19.3 17.9024 19.5239 18.1262 19.5239 18.4024V18.9981C19.5239 19.2742 19.3001 19.498 19.024 19.4981L9.53165 19.5C9.39759 19.5 9.26914 19.4462 9.17513 19.3506L4.22989 14.324C3.92337 14.0124 3.92337 13.5073 4.22989 13.1957L12.555 4.73368C12.8615 4.42211 13.3585 4.42211 13.665 4.73368L19.7701 10.9392C20.0766 11.2507 20.0766 11.7559 19.7701 12.0674L14.0296 17.9024Z"
          fill={`${color}`}
        />
      </svg>
    </div>
  );
}
